import React, {createContext, useContext, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import Popup from './Popup';
import SignInPopup from 'components/login/SignInPopup';

const PopupContext = createContext();

export const usePopup = () => useContext(PopupContext);

export const PopupProvider = ({children}) => {
    const [popupContent, setPopupContent] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [onCloseCallback, setOnCloseCallback] = useState(null);
    const [isStrict, setIsStrict] = useState(false);
    const keepOnPageChangeRef = useRef(false);
    const location = useLocation();
    const [isSizeIndependentAnchor, setIsSizeIndependentAnchor] = useState(false);

    const openPopup = (content, onClose, isStrict = false, keepOnPageChange = false) => {
        setPopupContent(content);
        setIsPopupOpen(true);
        setOnCloseCallback(() => onClose);
        setIsStrict(isStrict);
        keepOnPageChangeRef.current = keepOnPageChange;
        if (content?.type === SignInPopup) {
            setIsSizeIndependentAnchor(true);
        }
    };

    const closePopup = () => {
        setPopupContent(null);
        setIsPopupOpen(false);
        setIsStrict(false);
        setIsSizeIndependentAnchor(false);
        keepOnPageChangeRef.current = false;
        if (onCloseCallback) {
            onCloseCallback();
            setOnCloseCallback(null);
        }
    };

    useEffect(() => {
        console.log('location changed, closing popup');
        if (!keepOnPageChangeRef.current) {
            closePopup();
        }
    }, [location]);

    return (
        <PopupContext.Provider value={{openPopup, closePopup, isPopupOpen}}>
            {children}
            <Popup isOpen={isPopupOpen} onClose={closePopup} isStrict={isStrict}
                   isSizeIndependentAnchor={isSizeIndependentAnchor}>
                {popupContent}
            </Popup>
        </PopupContext.Provider>
    );
};
